import classNames from 'classnames';
import { Fragment, type FC } from 'react';
import { TextContainer } from 'src/components/shared/campaign/CampaignDetails/Condition/TextContainer';
import { NextImage } from 'src/components/shared/elements/NextImage';
import type { Tailwind } from 'styles/tw';

export type Props = {
  conditionTitleImageUrl: string;
  conditionTexts: string[];
  conditionTextsColor?: Tailwind['color'];
  conditionPlusIconImageUrl: string;
  conditionCompletionText: string;
  conditionsFlexDirection: Tailwind['flexDirection'];
  conditionTextContainerBackground?: string; // url(...) or color
  conditionTextContainerWidth?: Tailwind['width'];
  conditionTextContainerHeight?: Tailwind['height'];
  conditionTextContainerBorderColor?: Tailwind['borderColor'];
  conditionTextContainerBorderWidth?: Tailwind['borderWidth'];
};

export const Condition: FC<Props> = ({
  conditionTitleImageUrl,
  conditionTexts,
  conditionTextsColor,
  conditionTextContainerBackground,
  conditionTextContainerWidth,
  conditionTextContainerHeight,
  conditionTextContainerBorderColor,
  conditionTextContainerBorderWidth,
  conditionPlusIconImageUrl,
  conditionCompletionText,
  conditionsFlexDirection
}) => (
  <div
    className={classNames(
      'flex items-center flex-col justify-center gap-5 font-medium',
      'semiLg:gap-10',
      conditionTextsColor || ''
    )}
  >
    <div className="w-full flex justify-center items-center">
      <NextImage src={conditionTitleImageUrl} alt="condition-title" width={160} height={40} />
    </div>
    {!!conditionCompletionText && (
      <div className="flex justify-center">
        <p className="text-2xl">{conditionCompletionText}</p>
      </div>
    )}
    <div
      className={classNames(
        'w-full flex flex-col items-center justify-center gap-3 semiLg:gap-6',
        `semiLg:${conditionsFlexDirection}`
      )}
    >
      {conditionTexts.map((text, index) => (
        <Fragment key={index}>
          <TextContainer
            conditionsFlexDirection={conditionsFlexDirection}
            containerBackground={conditionTextContainerBackground}
            width={conditionTextContainerWidth}
            height={conditionTextContainerHeight}
            borderColor={conditionTextContainerBorderColor}
            borderWidth={conditionTextContainerBorderWidth}
            text={text}
          />
          {index < conditionTexts.length - 1 && (
            <div className="flex justify-center items-center">
              <NextImage src={conditionPlusIconImageUrl} alt="condition-plus-icon" width={36} height={36} />
            </div>
          )}
        </Fragment>
      ))}
    </div>
  </div>
);
